/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, TextField } from '@/components/Common';
import { TextfieldType } from '@/components/Common/TextField/TextField.types';
import { Modal } from '@/components/Layout';
import { ModalPositions } from '@/components/Layout/Modal/Modal.types';
import { TextEditor } from '@/components/Ui';
import { useEffect } from 'react';
import { Controller } from 'react-hook-form';
import { useHighlights } from './highlights.hook';
import { useGeneratedModule } from '../ContentGenerator/GeneratedModule/generatedModule.hook';

const HighlightsForm = ({
  selectedHighlight,
  moduleId,
}: {
  selectedHighlight: any;
  moduleId?: string;
}) => {
  const {
    register,
    handleSubmit,
    control,
    errors,
    onSubmit,
    setValue,
    isOpenHighlightModal,
    handleClose,
    highlightData,
    isEdit,
    setIsEdit,
    handleUpdate,
    addHighlightLoading,
    updateHighlightLoading,
  } = useHighlights();

  const { onSubmitGeneratedHighlight } = useGeneratedModule();

  useEffect(() => {
    if (highlightData) {
      setValue('term', highlightData.term);
      setIsEdit(true);
    } else if (selectedHighlight) {
      setValue('term', selectedHighlight.term);
      setIsEdit(true);
    }
  }, [highlightData, setIsEdit, setValue, selectedHighlight]);

  const submitHighlightData = (formData: any) => {
    if (isEdit) {
      if (selectedHighlight && moduleId) {
        onSubmitGeneratedHighlight(formData, moduleId, selectedHighlight._id);
      } else {
        handleUpdate(formData);
      }
    } else {
      onSubmit(formData);
    }
  };

  return (
    <Modal
      isOpen={isOpenHighlightModal}
      onClose={handleClose}
      position={ModalPositions.RIGHT}
      modalStyle="bg-black p-0 m-0"
      headerStyle="bg-black p-0 m-0"
    >
      <form onSubmit={handleSubmit(submitHighlightData)}>
        <div className="w-[47vw] h-[100vh] pl-[69px] pr-20 py-0 my-0">
          <div className="mb-7">
            <TextField
              placeholder="Terme"
              type={TextfieldType.INPUT}
              textFieldType={TextfieldType.INPUT}
              name="term"
              register={register('term')}
              helpText={errors.term?.message}
              errorStyle="text-red-500 text-xs !font-normal"
              className="!bg-[#1D1D1D] !w-[283px] h-[55px] mt-6 !border-[1.165px] !border-[#2F2E2E]"
            />
          </div>
          <div>
            <Controller
              name="definition"
              control={control}
              render={({ field }) => (
                <TextEditor
                  backgroundColor="#000"
                  onChange={field.onChange}
                  initialValue={
                    selectedHighlight
                      ? selectedHighlight?.definition.html
                      : highlightData?.definition.html
                  }
                />
              )}
            />
            {errors.definition && (
              <span className="text-red-500 text-xs mt-2">
                {errors.definition?.message}
              </span>
            )}
          </div>
          <div className="flex justify-end w-full my-4">
            <Button
              type="submit"
              title={
                isEdit
                  ? updateHighlightLoading
                    ? 'Modification...'
                    : 'Modifier'
                  : addHighlightLoading
                    ? 'Ajout en cours...'
                    : 'Ajouter'
              }
              className="w-[160px]"
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};

export default HighlightsForm;
